export const settings = {
  get: {
    ticketCategories: 'ticket-categories-received',
    scheduleCalendarSettings: 'schedule-settings-received',
    serviceProductTypes: 'service-product-types-received',
    estimatedServiceDeliveryTime: 'estimated-service-delivery-time-received',
    availableServiceStatus: 'available-service-status-received',
    pendingConnectionStatus: 'pending-connection-status-received',
    serviceStatusIcons: 'service-status-icons-received',
    buildingSettings: 'building-settings-received',
    accessSettings: 'access-settings-received'
  },
  update: 'settings-data-updated'
}
